import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { feedbackAndQuestionNoticeDetailsSchema } from '../../../common/validations/feedbackAndQuestionNotice'

import { get } from 'api/apiClient'
import { createBlobUrl } from 'views/DefectNotice/utils'

const params = (contractUuid: string, uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUuid}/feedbacks/${uuid}`],
  queryFn: async () => {
    const feedbackNotice = await get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/feedbacks/${uuid}`,
      feedbackAndQuestionNoticeDetailsSchema
    )
    const files = await Promise.all(
      (feedbackNotice.files ?? []).map(async (file) => ({
        ...file,
        url: await createBlobUrl(file.url),
      }))
    )
    return {
      ...feedbackNotice,
      files,
    }
  },
})

export const useAPIGetFeedbackNotice = (contractUuid: string, uuid: string) =>
  useQuery(params(contractUuid, uuid))

export const useAPIGetFeedbackNoticeSuspense = (
  contractUuid: string,
  uuid: string
) => useSuspenseQuery(params(contractUuid, uuid))
